import {EditVersionDocumentDto} from '../services/generated';
import {DocumentVersion} from './DocumentVersion';

export class DocumentVersionEdit extends DocumentVersion implements EditVersionDocumentDto {}
